import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBuildingBlocks: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconBuildingBlocks"><Path d="M2 18L10 22.5V19.5L2 15.0616V18ZM12 19.5V22.537L22 15.5V12.5L12 19.5ZM2 12.6676L10 17.0158V14L2 9.5404V12.6676ZM12 14V17L22 10V7L12 14ZM3 7.5L11 12L21 5.5L13 1L3 7.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBuildingBlocks;
